// Offers & Payments  form config

export const offersPaymentsFields = [
    {
        key: 'offers',
        name: 'Offers',
        fields: [
            {
                name: 'date_of_offer1',
                label: 'Date of Offer (1)',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_of_offer2',
                label: 'Date of Offer (2)',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_of_offer3',
                label: 'Date of Offer (3)',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_of_offer4',
                label: 'Date of Offer (4)',
                type: 'date',
                validation: {}
            },
            {
                name: 'offer_accepted',
                label: 'Offer Accepted?',
                type: 'text',
                validation: {}
            },
            {
                name: 'date_offer_rejected',
                label: 'Date Offer Rejected',
                type: 'date',
                validation: {}
            },
            {
                name: 'offer_rejection_reason',
                label: 'Offer Rejection Reason',
                type: 'text',
                validation: {}
            },
            {
                name: 'date_offer_accepted',
                label: 'Date Offer Accepted',
                type: 'date',
                validation: {}
            },
            {
                name: 'total_nb_hire_days_offered',
                label: 'Total Number of Hire Days Offered',
                type: 'integer',
                validation: {}
                // validation: [{ name: 'required' }]
            },
            {
                name: 'hire_group_offered',
                label: 'Hire Group Offered',
                type: 'text',
                validation: {}
            },
            {
                name: 'hire_daily_rate_offered',
                label: 'Hire Daily Rate Offered',
                type: 'float',
                validation: [{ name: 'required' }]
            },
            {
                name: 'hire_daily_rate_extra_per_day_offered',
                label: 'Hire Daily Rate Extra per day Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'auto',
                label: 'Auto',
                type: 'float',
                validation: {}
            },
            {
                name: 'estate',
                label: 'Estate',
                type: 'float',
                validation: {}
            },
            {
                name: 'dual_control',
                label: 'Dual Control',
                type: 'float',
                validation: {}
            },
            {
                name: 'top_box',
                label: 'Top Box',
                type: 'float',
                validation: {}
            },
            {
                name: 'pannier',
                label: 'Pannier',
                type: 'float',
                validation: {}
            },
            {
                name: 'non_standard_driver_charge',
                label: 'Non Standard Driver Charge (ABI GTA)',
                type: 'float',
                validation: {}
            },
            {
                name: 'collision_damage_waiver',
                label: 'Collision Damage Waiver',
                type: 'float',
                validation: {}
            },
            {
                name: 'total_daily_rate_offered',
                label: 'Total Daily Rate Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'total_daily_rate_vat_offered',
                label: 'Total Daily Rate VAT Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'total_hire_offered',
                label: 'Total Hire Offered',
                type: 'float',
                validation: [{ name: 'required' }]
            },
            {
                name: 'total_hire_offered_vat',
                label: 'Total Hire Offered VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'abi_admin_offered',
                label: 'ABI Admin Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'abi_admin_offered_vat',
                label: 'ABI Admin Offered VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'repair_offered_total_no_vat',
                label: 'Repair Offered Total (exc VAT)',
                type: 'float',
                validation: {}
            },
            {
                name: 'repair_offered_total_vat',
                label: 'Repair Offered Total VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'labour_hours_offered',
                label: 'Labour Hours Offered',
                type: 'integer',
                validation: {}
            },
            {
                name: 'labour_rate_per_hour_no_vat_offered',
                label: 'Labour Rate Per Hour (exc VAT) Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'labour_rate_per_hour_vat_offered',
                label: 'Labour Rate Per Hour VAT Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'labour_total_no_vat_offered',
                label: 'Labour Total (exc VAT) Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'labour_total_vat_offered',
                label: 'Labour Total VAT Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'parts_total_no_vat_offered',
                label: 'Parts Total (Exc VAT) Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'parts_total_vat_offered',
                label: 'Parts VAT Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'paint_materials_total_no_vat_offered',
                label: 'Paint & Materials Total (Exc VAT) Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'paint_materials_total_vat_offered',
                label: 'Paints & Materials VAT Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'specialist_total_no_vat_offered',
                label: 'Specialist Total (Exc VAT) Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'specialist_total_vat_offered',
                label: 'Specialist VAT Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'engineers_fee_offered',
                label: 'Engineers Fee Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'engineers_fee_offered_vat',
                label: 'Engineers Fee Offered VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'repair_abi_admin_offered',
                label: 'Repair ABI Admin Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'repair_abi_admin_vat',
                label: 'Repair ABI Admin VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'storage_offered',
                label: 'Storage Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'storage_offered_vat',
                label: 'Storage Offered VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'recovery_offered',
                label: 'Recovery Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'recovery_offered_vat',
                label: 'Recovery Offered VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'dimunition_offered',
                label: 'Diminution Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'dimunition_offered_vat',
                label: 'Diminution Offered VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'other_offered',
                label: 'Other Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'other_offered_vat',
                label: 'Other Offered VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'total_offered',
                label: 'Total Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'total_offered_vat',
                label: 'Total Offered VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'grand_total_offered',
                label: 'Grand Total Offered',
                type: 'float',
                validation: {}
            },
            {
                name: 'total_hire_period_offered',
                label: 'Total Hire Period Offered',
                type: 'integer',
                validation: [{ name: 'required' }]
            }
        ]
    },
    {
        key: 'payments',
        name: 'Payments',
        fields: [
            {
                name: 'total_nb_hire_days_paid',
                label: 'Total Number of Hire Days Paid',
                type: 'integer',
                validation: {}
            },
            {
                name: 'hire_group_paid',
                label: 'Hire Group Paid',
                type: 'text',
                validation: {}
            },
            {
                name: 'hire_daily_rate_paid',
                label: 'Hire Daily Rate Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'hire_daily_rate_extra_per_day_paid',
                label: 'Hire Daily Rate Extra per day Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'auto_paid',
                label: 'Auto',
                type: 'float',
                validation: {}
            },
            {
                name: 'estate_paid',
                label: 'Estate',
                type: 'float',
                validation: {}
            },
            {
                name: 'dual_control_paid',
                label: 'Dual Control',
                type: 'float',
                validation: {}
            },
            {
                name: 'top_box_paid',
                label: 'Top Box',
                type: 'float',
                validation: {}
            },
            {
                name: 'pannier_paid',
                label: 'Pannier',
                type: 'float',
                validation: {}
            },
            {
                name: 'non_standard_driver_charge_paid',
                label: 'Non Standard Driver Charge (ABI GTA)',
                type: 'float',
                validation: {}
            },
            {
                name: 'collision_damage_waiver_paid',
                label: 'Collision Damage Waiver',
                type: 'float',
                validation: {}
            },
            {
                name: 'total_daily_rate_paid',
                label: 'Total Daily Rate Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'total_daily_rate_vat_paid',
                label: 'Total Daily Rate VAT Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'total_hire_paid',
                label: 'Total Hire Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'total_hire_paid_vat',
                label: 'Total Hire Paid VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'abi_admin_paid',
                label: 'ABI Admin Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'abi_admin_paid_vat',
                label: 'ABI Admin Paid VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'repair_paid_total_no_vat',
                label: 'Repair Paid Total (exc VAT)',
                type: 'float',
                validation: {}
            },
            {
                name: 'repair_paid_total_vat',
                label: 'Repair Paid Total VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'labour_hours_paid',
                label: 'Labour Hours Paid',
                type: 'integer',
                validation: {}
            },
            {
                name: 'labour_rate_per_hour_no_vat_paid',
                label: 'Labour Rate Per Hour (exc VAT) Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'labour_rate_per_hour_vat_paid',
                label: 'Labour Rate Per Hour VAT Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'labour_total_no_vat_paid',
                label: 'Labour Total (exc VAT) Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'labour_total_vat_paid',
                label: 'Labour Total VAT Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'parts_total_no_vat_paid',
                label: 'Parts Total (Exc VAT) Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'parts_total_vat_paid',
                label: 'Parts VAT Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'paint_materials_total_no_vat_paid',
                label: 'Paint & Materials Total (Exc VAT) Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'paint_materials_total_vat_paid',
                label: 'Paints & Materials VAT Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'specialist_total_no_vat_paid',
                label: 'Specialist Total (Exc VAT) Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'specialist_total_vat_paid',
                label: 'Specialist VAT Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'engineers_fee_paid',
                label: 'Engineers Fee Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'engineers_fee_paid_vat',
                label: 'Engineers Fee Paid VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'repair_abi_admin_paid',
                label: 'Repair ABI Admin Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'repair_abi_admin_paid_vat',
                label: 'Repair ABI Admin Paid VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'storage_paid',
                label: 'Storage Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'storage_paid_vat',
                label: 'Storage Paid VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'recovery_paid',
                label: 'Recovery Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'recovery_paid_vat',
                label: 'Recovery Paid VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'dimunition_paid',
                label: 'Diminution Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'dimunition_paid_vat',
                label: 'Diminution Paid VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'other_paid',
                label: 'Other Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'other_paid_vat',
                label: 'Other Paid VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'late_payment_penalty_due',
                label: 'Late Payment Penalty Due?',
                type: 'text',
                validation: {}
            },
            {
                name: 'reason_for_late_payment_penalty',
                label: 'Reason for Late Payment Penalty',
                type: 'text',
                validation: {}
            },
            {
                name: 'hire_late_payment_penalty_amount',
                label: 'Hire Late Payment Penalty Amount',
                type: 'float',
                validation: {}
            },
            {
                name: 'admin_late_payment_penalty_amount',
                label: 'Admin Late Payment Penalty Amount',
                type: 'float',
                validation: {}
            },
            {
                name: 'repair_late_payment_penalty_amount',
                label: 'Repair Late Payment Penalty Amount',
                type: 'float',
                validation: {}
            },
            {
                name: 'repair_admin_late_payment_penalty_amount',
                label: 'Repair Admin Late Payment Penalty Amount',
                type: 'float',
                validation: {}
            },
            {
                name: 'total_late_payment_penalty_amount',
                label: 'Total Late Payment Penalty Amount',
                type: 'float',
                validation: {}
            },
            {
                name: 'total_paid',
                label: 'Total Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'total_paid_vat',
                label: 'Total Paid VAT',
                type: 'float',
                validation: {}
            },
            {
                name: 'grand_total_paid',
                label: 'Grand Total Paid',
                type: 'float',
                validation: {}
            }
        ]
    }
];
